import React from "react";
import { Button } from "react-admin";
import { useModal } from "@logora/debate.dialog.modal";
import { Box } from "@mui/material";
import { AddAlertIcon } from "@logora/parliament.icons.regular_icons";
import { AlertModal } from "./AlertModal";
import styles from "./AlertList.module.scss";

export const AlertListEmpty = () => {
	const { showModal } = useModal();
	
	return (
		<Box
			display="flex"
			justifyContent="center"
			alignItems="center"
			flexDirection="column"
			p={5}
		>
			<AddAlertIcon className={styles.alertIcon} width={80} height={80} />
			<Button
				className={styles.mainButton}
				label="Ajouter une alerte"
				onClick={() =>
					showModal(
						<AlertModal onCreateAlert={props.onCreateAlert} />
					)
				}
			/>
		</Box>
	);
};
